import { ReactElement } from 'react';
import { Modal } from '@weareopenr/component-library';
import ModalImg from '../../assets/images/section-modal.png';
import { CreateTimetableModalContent } from './CreateTimetableModalContent';
import { ICreateTimetableModalProps } from './types';

export const CreateTimetableModal = ({ open, closeModal }: ICreateTimetableModalProps): ReactElement => (
  <Modal
    open={open}
    closeModal={closeModal}
    image={ModalImg}
    imageAlt="Picture of four beautifully displayed breakfast plates"
  >
    <CreateTimetableModalContent closeModal={closeModal} />
  </Modal>
);

export default CreateTimetableModal;
